import PropTypes from "prop-types";
import React, { useEffect, useMemo } from "react";
import { connect, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Form } from "semantic-ui-react";
import { getCropsList } from "actions/Farms/crops";
import { isEmpty } from "lodash";
import { farmsOptionsSelector } from "selectors/farms";
import { cropsSelector } from "selectors/crops";

const SelectFarm = ({
  actions: { getCropsList },
  cropsList,
  isFetching,
  onChange,
  usedProductsIds,
  value,
  name
}) => {
  const farmsOptions = useSelector(farmsOptionsSelector);
  const filteredFarmsOptions = farmsOptions.filter(
    o => !usedProductsIds.includes(o.value) || o.value === value
  );
  useEffect(() => {
    if (!isFetching && isEmpty(cropsList)) {
      getCropsList();
    }
  }, [isFetching, getCropsList]);

  const options = useMemo(
    () => cropsList.sort((c1, c2) => c1.text.localeCompare(c2.name)),
    [cropsList]
  );

  return (
    <Form.Dropdown
      fluid
      placeholder="Type or select the farm"
      options={filteredFarmsOptions}
      onChange={(_, { value }) =>
        onChange(filteredFarmsOptions.find(item => item.value === value))
      }
      search
      selection
      name={name}
      value={value}
    />
  );
};

SelectFarm.propTypes = {
  actions: PropTypes.object.isRequired,
  cropsList: PropTypes.array.isRequired,
  disabled: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  minItemForSearch: PropTypes.bool,
  native: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool.isRequired,
  showArchived: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.array.isRequired,
    PropTypes.number.isRequired
  ])
};

SelectFarm.defaultProps = {
  cropsList: [],
  disabled: false,
  error: false,
  isFetching: false,
  minItemForSearch: 10,
  native: false,
  onChange: () => {},
  required: false,
  showArchived: false
};

const mapStateToProps = state => {
  return {
    cropsList: cropsSelector(state),
    isFetching: state.crops.isFetching
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      getCropsList
    },
    dispatch
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectFarm);
